import React from 'react';
import { Link } from 'react-router-dom'; // ✅ Import Link component
import LoginForm from '../../auth/LoginForm'; // ✅ Corrected path

const LoginPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col justify-center px-4">
      <div className="max-w-md w-full mx-auto bg-white p-8 rounded-md shadow">
        <div className="text-center mb-6">
          <img src="/logo.jpeg" alt="Logo" className="mx-auto h-16 w-16" />
          <h2 className="mt-2 text-2xl font-bold text-gray-900">Login to ShreeGuruCool</h2>
        </div>
        <LoginForm />
        <div className="mt-6 text-sm text-center text-gray-600">
          Don’t have an account?{' '}
          <Link
            to="/signup" // ✅ Use Link component and correct path
            className="text-blue-600 hover:underline font-medium"
          >
            Register
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;